export default __webpack_public_path__ + "static/media/valves.092f0993.png";